import type React from 'react';

import type { WidgetProps } from '@rjsf/utils';
import numeral from 'numeral';

import { cn } from '@/shadcn/lib/utils';

type Props = Pick<WidgetProps, 'value'>;

export const NumericWidget: React.FC<Props> = ({ value }) => {
  const error = value && value < 0;

  return (
    <div className={cn('text-base', error && 'text-destructive')}>
      {value !== null ? numeral(value).format('0,0.00') : ''}
    </div>
  );
};
